const EN = {
    buttons: {
        accept: 'Accept',
        confirm: 'Confirm',
        cancel: 'Cancel',
        back: 'Back',
        block: 'Block',
        unblock: 'Unblock',
        unsubscribe: 'Unsubscribe',
        save: 'Save',
        discard: 'Discard changes',
        reportPayment: 'Report payment',
        reject: 'Reject',
        approve: 'Approve',
        login: 'Login',
        sendEmail: 'Send email',
        close: 'Close',
        preview: 'Preview',
        program: 'Program',
        retry: 'Retry',
        modify: 'Modify',
        submit: 'Submit',
    },
    errors: {
        // eslint-disable-next-line quotes
        generalTitle: `Something did not go as expected`,
        generalDescription: 'We apologize. It was not possible to complete the operation.',
        user: 'The user already exist.',
        emailAlreadyExists: 'The email entered already exists for another user.',
        notFound: 'An error has ocurred when trying to load the client.',
        downloadFile: 'An error occurred while downloading the report. Please try again.',
        embedLoad: 'Content could not be loaded. Please try again.',
        loadData: 'The data could not be loaded. Please try again.',
        pageNotFound: 'The page you are looking for does not exist',
        moduleLoad: 'This section could not be loaded. Please try again.',
    },
    filter: {
        searchPlaceholder: 'Search...',
        search: 'Search',
        title: 'Filter',
        dateRange: 'Date From-To',
        registrationDateRange: 'Registration Date From-To',
        modal: {
            title: 'Searching filters',
            date: {
                title: 'Date',
                from: 'From date',
                to: 'To date'
            },
            apply: 'Apply',
            delete: 'Delete filters'
        }
    },
    pagination: {
        of: 'of',
        empty: 'No records found',
        warning: `We can not charge more pages.<br />
        apply filters<br />
        to get more results.`
    },
    downloadExcel: 'Download Excel',
    loading: 'Loading...',
    watch: 'Watch',
    reset: 'Reset',
};

export default EN;
